<a class="song" [routerLink]="'/artists/' + artist.id">
  <div class="song__cover song__cover-round">
    <img [src]="artist.pictureUrl" [alt]="artist.title" appReplaceMissingImage />
  </div>
  <div class="song__content">
    <div class="song__name">
      <div class="song__name-link">{{artist.title}}</div>
    </div>
  </div>
</a>
